/***
 * 路由
 * @type {{path: string, component: {name}}}
 */
export const route = {
  redirect: '/home/hall'
};

/***
 * 进入路由前的操作
 */
export const tasks = [
  function (a) {
    return new Promise(resolve => {
      setTimeout(() => {
        console.log('进入路由前1');
        resolve();
      }, 300);
    });
  },
  function () {
    return new Promise(resolve => {
      setTimeout(() => {
        console.log('进入路由前2');
        resolve();
      }, 200);
    });
  }
];



// WEBPACK FOOTER //
// ./src/pages/index.js